<div
    *ngIf="
        data.componentName === DialogInvokingComponents.DeleteAddress ||
        data.componentName === DialogInvokingComponents.CancelOrder ||
        data.componentName === DialogInvokingComponents.MyStructuresList ||
        data.componentName === DialogInvokingComponents.SaveDesignConfirmation ||
        data.componentName === DialogInvokingComponents.RemoveFromNotification ||
        data.componentName === DialogInvokingComponents.DuplicateStructure
    "
>
    <div class="top-container">
        <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
        <button mat-icon-button *ngIf="data.image" class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
        <div class="item-container">
            <p>{{ data.content }}</p>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <app-button variant="hero" buttonClass="explore-btn shadow-btn" (onClick)="closeDialogPublish()">
            {{ data.firstBtn }}
        </app-button>
        <app-button
            variant="white"
            *ngIf="data.secondBtn"
            (onClick)="closeDialog()"
            buttonClass="explore-btn shadow-btn"
        >
            {{ data.secondBtn }}
        </app-button>
    </mat-dialog-actions>
</div>

<!-- <div *ngIf="data.componentName === DialogInvokingComponents.ActiveCoupon">
    <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content class="mat-typography">
        <div class="item-container">
            <table mat-table [dataSource]="data.activeCoupon">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox
                            [(ngModel)]="element.selected"
                            (change)="toggleSelection(element, $event)"
                        ></mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="couponCode">
                    <th mat-header-cell *matHeaderCellDef>{{ "genericDialogBox.label.couponCode" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.couponCode }}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef>{{ "genericDialogBox.label.description" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.description }}</td>
                </ng-container>

                <tr
                    mat-header-row
                    class="table-header-row"
                    *matHeaderRowDef="['select', 'couponCode', 'description']"
                ></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: ['select', 'couponCode', 'description']"
                    class="table-data-row"
                ></tr>
            </table>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <button mat-flat-button (click)="applyCoupon()" [disabled]="selectedCoupons.length === 0" class="save-btn">
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button (click)="closeDialog()" class="cancel-btn">
            {{ data.secondBtn }}
        </button>
    </mat-dialog-actions>
</div> -->

<div *ngIf="data.componentName === DialogInvokingComponents.ChangeAddress">
    <div class="top-container">
        <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
        <button mat-icon-button class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography changeAddress-content">
        <div class="address-container">
            <mat-radio-group
                aria-label="Select an option"
                class="address-radio-group"
                [(ngModel)]="data.addressId"
                (change)="onAddressChange()"
                color="primary"
            >
                <div
                    class="address-card"
                    *ngFor="let address of data.addresses"
                    [ngClass]="{
                        'selected-address-card': address['id'] === data.addressId
                    }"
                >
                    <label class="address-label">
                        <mat-radio-button class="my-radio-button" [value]="address.id">
                            <div class="address-content">
                                <div class="address-content-heading">
                                    {{ address.name }}, {{ address.pincode }}
                                    <span class="address-type">{{ address.addressType }}</span>
                                </div>

                                <p class="address-content-body">
                                    {{ address.houseNumber }}, {{ address.address }}, {{ address.city }},
                                    {{ address.state }}
                                </p>
                            </div>
                        </mat-radio-button>
                    </label>
                </div>
            </mat-radio-group>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <button mat-flat-button (click)="onAddAddress()" class="save-btn">
            {{ "genericDialogBox.button.addNewBtn" | translate }}
        </button>
    </mat-dialog-actions>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.AddAddress">
    <div class="top-container">
        <h2 class="title" mat-dialog-title [autofocus]="true">{{ data.title }}</h2>
        <button mat-icon-button class="close-button" (click)="closeDialog()" autoFocus="false">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="mat-typography addAddress-content">
        <div class="user-details-container" *ngIf="data.withUserProfileDetails; else withoutUserProfileDetails">
            <div class="personal-info-container">
                <h2>{{ "genericDialogBox.heading.personalInfo" | translate }}</h2>
                <profile-details
                    [isInDialog]="true"
                    [hideAgeAndShowMobile]="data.hideAgeAndShowMobile"
                    (profileData)="receiveProfileData($event)"
                    #profileDetailRef
                ></profile-details>
            </div>

            <div class="address-container">
                <h2>{{ "genericDialogBox.heading.address" | translate }}</h2>
                <app-address
                    [isInDialog]="true"
                    [selectedAddressId]="data.addressId"
                    [showNameAndMobile]="true"
                    (addressData)="receiveAddressData($event)"
                    #addressDetailsRef
                ></app-address>
            </div>
        </div>

        <ng-template #withoutUserProfileDetails>
            <app-address
                [isInDialog]="true"
                [selectedAddressId]="data.addressId"
                [showNameAndMobile]="true"
                (addressData)="receiveAddressData($event)"
                #addressDetailsRef
            ></app-address>
        </ng-template>
    </mat-dialog-content>

    <mat-dialog-actions class="actions-container" align="end">
        <button
            mat-flat-button
            [mat-dialog-close]="{
                userDetails: profile,
                addressDetails: address
            }"
            [disabled]="!isFormDataValid()"
            class="save-btn"
        >
            {{ "genericDialogBox.button.submitBtn" | translate }}
        </button>
        <button mat-flat-button class="cancel-btn" (click)="closeDialog()">
            {{ "genericDialogBox.button.cancelBtn" | translate }}
        </button>
    </mat-dialog-actions>
</div>

@if(data.componentName === DialogInvokingComponents.ProductReview) {
<div class="review-dialog-container">
    <div class="top-container">
        <h3 class="title">{{ "genericDialogBox.approveRejectComment.title" | translate }}</h3>
        <app-button (click)="closeDialog()" [variant]="'ghost'" [buttonClass]="'circle-btn'">
            <mat-icon>close</mat-icon>
        </app-button>
    </div>

    <form [formGroup]="productReviewForm" class="review-container">
        <div class="radio-container">
            <div class="review-radio-input-container">
                <input class="radio-input" formControlName="action" type="radio" value="Approved" id="approved" />
                <label for="approved">{{ "genericDialogBox.approveRejectComment.approve" | translate }}</label>
            </div>

            <div class="review-radio-input-container">
                <input class="radio-input" formControlName="action" type="radio" value="Rejected" id="rejected" />
                <label for="rejected">{{ "genericDialogBox.approveRejectComment.reject" | translate }}</label>
            </div>
        </div>
        @if(productReviewForm.get('action')?.value === reviewStatus.Rejected) {
        <textarea
            formControlName="reason"
            id="reason"
            name="reason"
            [placeholder]="'genericDialogBox.approveRejectComment.placeholder.reason' | translate"
        ></textarea>
        }

        <div class="btn-container">
            <app-button
                [mat-dialog-close]="productReviewForm.value"
                variant="hero"
                buttonClass="explore-btn shadow-btn"
                [disabled]="productReviewForm.invalid"
            >
                {{ "genericDialogBox.button.submitBtn" | translate }}
            </app-button>
        </div>
    </form>
</div>
}

<div
    *ngIf="
        data.componentName === DialogInvokingComponents.CourierInfo ||
        data.componentName === DialogInvokingComponents.ReturnOrder ||
        data.componentName === DialogInvokingComponents.PickupScheduled ||
        data.componentName === DialogInvokingComponents.ExchangeMessage ||
        data.componentName === DialogInvokingComponents.RefundInitiated ||
        data.componentName === DialogInvokingComponents.RejectStructure
    "
>
    <div class="courier-information">
        <h2 class="title" mat-dialog-title>{{ data.title }}:</h2>
        <mat-dialog-content class="mat-typography">
            <p *ngIf="data.content">{{ data.content }}</p>
            <br />
            <form [formGroup]="courierForm">
                <div class="item-container" *ngFor="let input of data.inputs">
                    <mat-form-field appearance="outline" class="example-full-width dense-3">
                        <input
                            matInput
                            *ngIf="input.type !== 'date' && input.type !== 'time'"
                            [formControlName]="input.controlName"
                            [placeholder]="input.placeholder"
                            [value]="input.value"
                            [type]="input.type"
                        />

                        <input
                            matInput
                            *ngIf="input.type === 'time'"
                            [formControlName]="input.controlName"
                            [ngxTimepicker]="toggleTimepicker"
                            [disableClick]="true"
                            readonly
                            [placeholder]="input.placeholder"
                        />
                        <mat-icon matSuffix *ngIf="input.type === 'time'" (click)="toggleTimepicker.open()"
                            >schedule</mat-icon
                        >
                        <ngx-material-timepicker #toggleTimepicker></ngx-material-timepicker>

                        <input
                            matInput
                            *ngIf="input.type === 'date'"
                            [formControlName]="input.controlName"
                            [placeholder]="input.placeholder"
                            [matDatepicker]="picker"
                            [value]="input.value"
                            [min]="todayDate"
                            [disabled]="true"
                            readonly
                        />
                        <mat-datepicker-toggle
                            *ngIf="input.type === 'date'"
                            matSuffix
                            [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </form>
        </mat-dialog-content>
        <mat-dialog-actions class="actions-container" align="end">
            <button
                mat-flat-button
                [mat-dialog-close]="true"
                class="save-btn"
                (click)="save()"
                [disabled]="!this.courierForm.valid"
            >
                {{ data.firstBtn }}
            </button>
            <button mat-flat-button (click)="closeDialog()" class="cancel-btn" *ngIf="data.secondBtn">
                {{ data.secondBtn }}
            </button>
        </mat-dialog-actions>
    </div>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.ReturnOrderCod">
    <div class="courier-information">
        <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
        <mat-dialog-content class="mat-typography">
            <p *ngIf="data.content">{{ data.content }}</p>
            <br />
            <form [formGroup]="returnOrderForm">
                <div class="item-container">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="reason" placeholder="Reason for Returning" type="text" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-error
                        class="text-red"
                        *ngIf="
                            returnOrderForm.get('reason')?.hasError('required') &&
                            returnOrderForm.get('reason')?.touched
                        "
                    >
                        {{ "genericDialogBox.label.return" | translate }}
                        {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                    </mat-error>
                </div>
                <p>{{ data.content2 }}</p>

                <div>
                    <div class="radio-group">
                        <mat-radio-group formControlName="refundOption">
                            <mat-radio-button value="bankDetails">{{
                                "genericDialogBox.label.bankDetails" | translate
                            }}</mat-radio-button>
                            <mat-radio-button value="upi">{{
                                "genericDialogBox.label.upiId" | translate
                            }}</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <!-- Bank Details Section -->
                    <div
                        *ngIf="returnOrderForm.get('refundOption')?.value === 'bankDetails'"
                        class="boundary"
                        formGroupName="bankDetails"
                    >
                        <div class="item-container">
                            <mat-form-field class="example-full-width">
                                <input
                                    matInput
                                    formControlName="accountHolderName"
                                    placeholder="Insert account holder name"
                                    type="text"
                                />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm
                                        .get('bankDetails')
                                        ?.get('accountHolderName')
                                        ?.hasError('required') &&
                                    returnOrderForm.get('bankDetails')?.get('accountHolderName')?.touched
                                "
                            >
                                {{ "genericDialogBox.label.accountHolderName" | translate }}
                                {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                            </mat-error>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm
                                        .get('bankDetails')
                                        ?.get('accountHolderName')
                                        ?.hasError('invalidAccountHolderName') &&
                                    returnOrderForm.get('bankDetails')?.get('accountHolderName')?.touched
                                "
                            >
                                {{ "genericDialogBox.invalidMessage.accountNameInvalid" | translate }}
                            </mat-error>
                        </div>

                        <div class="item-container">
                            <mat-form-field class="example-full-width">
                                <input
                                    matInput
                                    formControlName="accountNumber"
                                    placeholder="Insert bank account number"
                                />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm.get('bankDetails')?.get('accountNumber')?.hasError('required') &&
                                    returnOrderForm.get('bankDetails')?.get('accountNumber')?.touched
                                "
                            >
                                {{ "genericDialogBox.label.accountNo" | translate }}
                                {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                            </mat-error>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm
                                        .get('bankDetails')
                                        ?.get('accountNumber')
                                        ?.hasError('invalidAccountNumber') &&
                                    returnOrderForm.get('bankDetails')?.get('accountNumber')?.touched
                                "
                            >
                                {{ "genericDialogBox.invalidMessage.accountnoInvalid" | translate }}
                            </mat-error>
                        </div>

                        <div class="item-container">
                            <mat-form-field class="example-full-width">
                                <input matInput formControlName="ifscCode" placeholder="Insert IFSC code" type="text" />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm.get('bankDetails')?.get('ifscCode')?.hasError('required') &&
                                    returnOrderForm.get('bankDetails')?.get('ifscCode')?.touched
                                "
                            >
                                {{ "genericDialogBox.label.ifscCode" | translate }}
                                {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                            </mat-error>
                            <mat-error
                                class="text-red"
                                *ngIf="
                                    returnOrderForm.get('bankDetails')?.get('ifscCode')?.hasError('invalidIfsc') &&
                                    returnOrderForm.get('bankDetails')?.get('ifscCode')?.touched
                                "
                            >
                                {{ "genericDialogBox.invalidMessage.ifscInvalid" | translate }}
                            </mat-error>
                        </div>
                    </div>

                    <!-- UPI Section -->
                    <div
                        *ngIf="returnOrderForm.get('refundOption')?.value === 'upi'"
                        class="boundary"
                        formGroupName="upi"
                    >
                        <div class="item-container">
                            <mat-form-field class="example-full-width">
                                <input matInput formControlName="upiId" placeholder="Insert UPI" type="email" />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-error
                                class="text-red"
                                *ngIf="returnOrderForm.get('upi')?.get('upiId')?.hasError('invalidUPI')"
                            >
                                {{ "genericDialogBox.invalidMessage.upiIdInvalid" | translate }}
                            </mat-error>
                        </div>
                    </div>
                </div>
            </form>
        </mat-dialog-content>
        <mat-dialog-actions class="actions-container" align="end">
            <button
                mat-flat-button
                [mat-dialog-close]="true"
                class="save-btn"
                (click)="returnOrderData()"
                [disabled]="!this.returnOrderForm.valid"
            >
                {{ data.firstBtn }}
            </button>
            <button mat-flat-button (click)="closeDialog()" class="cancel-btn" *ngIf="data.secondBtn">
                {{ data.secondBtn }}
            </button>
        </mat-dialog-actions>
    </div>
</div>

<div
    *ngIf="
        data.componentName === DialogInvokingComponents.ImageSlider ||
        data.componentName === DialogInvokingComponents.PreviewImage
    "
>
    <mat-dialog-content class="swiper-image-dialog-content">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" *ngFor="let img of data.imageSlider">
                    <img [src]="img.image" alt="Slide image" />
                </div>
            </div>
            <div class="swiper-button-next" (click)="goToNextSlide()"></div>
            <div class="swiper-button-prev" (click)="goToPrevSlide()"></div>
        </div>
        <div class="image-container" *ngIf="data.image">
            <img [src]="data.image" alt="Preview" />
        </div>
    </mat-dialog-content>
</div>

<div class="structure-detials-container" *ngIf="data.componentName === DialogInvokingComponents.StructureDetails">
    <h2 class="title" mat-dialog-title>{{ data.title }}</h2>

    <mat-dialog-content class="mat-typography">
        <form [formGroup]="saveStructureForm">
            <div class="input-field">
                <label for="structureName" class="required"
                    >{{ "genericDialogBox.label.structureName" | translate }}:</label
                >
                <input
                    id="structureName"
                    type="text"
                    formControlName="structureName"
                    placeholder="Give your structure a name"
                />
                <div *ngIf="isInvalid(saveStructureForm, 'structureName')">
                    <div *ngIf="isInvalid(saveStructureForm, 'structureName', 'required')" class="error-text">
                        {{ "genericDialogBox.label.structureName" | translate }}
                        {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                    </div>
                    <div *ngIf="isInvalid(saveStructureForm, 'structureName', 'leadingSpaces')" class="error-text">
                        {{ "genericDialogBox.label.structureName" | translate }}
                        {{ "genericDialogBox.invalidMessage.whiteSpaceInvalid" | translate }}
                    </div>
                </div>
            </div>
            <div class="input-field">
                <label for="structureDescription" class="required">{{
                    "genericDialogBox.label.description" | translate
                }}</label>
                <textarea
                    id="structureDescription"
                    rows="4"
                    formControlName="structureDescription"
                    placeholder="Brief description about the structure"
                ></textarea>

                <div *ngIf="isInvalid(saveStructureForm, 'structureDescription')">
                    <div *ngIf="isInvalid(saveStructureForm, 'structureDescription', 'required')" class="error-text">
                        {{ "genericDialogBox.label.description" | translate }}
                        {{ "genericDialogBox.invalidMessage.mandatory" | translate }}
                    </div>
                    <div
                        *ngIf="isInvalid(saveStructureForm, 'structureDescription', 'leadingSpaces')"
                        class="error-text"
                    >
                        {{ "genericDialogBox.label.description" | translate }}
                        {{ "genericDialogBox.invalidMessage.whiteSpaceInvalid" | translate }}
                    </div>
                </div>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions class="actions-container" align="end">
        <button mat-flat-button class="save-btn" (click)="confirmationDialog()" [disabled]="saveStructureForm.invalid">
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button (click)="closeDialog()" *ngIf="data.secondBtn" class="cancel-btn">
            {{ data.secondBtn }}
        </button>
    </mat-dialog-actions>
</div>

<!-- my structure properties  -->
<div *ngIf="data.componentName === DialogInvokingComponents.MyStructuresListProperties">
    <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content class="mat-typography">
        <form [formGroup]="myStructureListForm">
            <!--  Structure Name  -->
            <div>
                <label for="description"
                    >{{ "genericDialogBox.label.name" | translate }}:<span class="required"> *</span></label
                >
                <input type="text" id="description" formControlName="myStructureName" required autocomplete="off" />
            </div>
            <!-- Structure Description  -->
            <div>
                <label>{{ "genericDialogBox.label.description" | translate }}:</label>
                <textarea formControlName="myStructureDescription"></textarea>
            </div>
            <!-- Status  -->
            <div>
                <label>{{ "genericDialogBox.label.status" | translate }}:</label>
                <div>
                    <mat-select formControlName="status">
                        <mat-option
                            *ngFor="let status of myStructureStatus"
                            [value]="status.value"
                            [disabled]="disableStatus(status.value)"
                            >{{ status.name }}</mat-option
                        >
                    </mat-select>
                </div>
            </div>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <button
            mat-flat-button
            (click)="updateStructureData()"
            [disabled]="myStructureListForm.invalid || isStatusDisabled()"
            class="save-btn"
        >
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button (click)="closeDialog()" *ngIf="data.secondBtn" class="cancel-btn">
            {{ data.secondBtn }}
        </button>
    </mat-dialog-actions>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.DeleteAdvertisement" class="container">
    <div class="top-container">
        <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
        <button mat-icon-button *ngIf="data.image" class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
        <div class="banner-item-container">
            <p>{{ data.content }}</p>
            <div class="banner-image-container" *ngIf="data.image">
                <div class="banner-image">
                    <img [src]="data.image" alt="Product Image" *ngIf="data.image; else noImage" />

                    <ng-template #noImage>
                        <div class="banner-image-placeholder"></div>
                    </ng-template>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <button mat-flat-button [mat-dialog-close]="true" class="save-btn">
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button (click)="closeDialog()" *ngIf="data.secondBtn" class="cancel-btn">
            {{ data.secondBtn }}
        </button>
    </mat-dialog-actions>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.EmailMessage" class="container">
    <h1 class="title" mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content [innerHTML]="data.message"></div>
    <div class="email-notification-btn-container" mat-dialog-actions>
        <button mat-flat-button class="save-btn" (click)="closeDialog()">
            {{ "genericDialogBox.button.closeBtn" | translate }}
        </button>
    </div>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.ColorCustomization" class="container">
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <div class="radio-content" mat-dialog-content>
        <div class="radio-contianer" *ngFor="let option of data.inputs[0].options" (click)="$event.stopPropagation()">
            <label>
                {{ option.label }}
            </label>
            <input type="radio" [value]="option.value" [(ngModel)]="selectedOption" name="faceOption" />
        </div>
    </div>
    <div mat-dialog-actions class="actions-container">
        <button mat-button class="save-btn" (click)="onConfirm()">
            {{ "genericDialogBox.button.confirmBtn" | translate }}
        </button>
        <button mat-button class="cancel-btn" (click)="closeDialog()">
            {{ "genericDialogBox.button.cancelBtn" | translate }}
        </button>
    </div>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.popUP360" class="container">
    <div>
        <div class="title360">
            <span>{{ data.title }}</span>
        </div>
        <div mat-dialog-content class="three-sixty-view">
            <app-viewer360 [glbURL]="data.glbUrl"></app-viewer360>
        </div>

        <button mat-icon-button class="close-button360" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.OnBoarding" class="container">
    <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
    <div mat-dialog-content class="mat-typography">
        <p>{{ data.content }}</p>
    </div>

    @if (hasCompletedTour) {
    <ul class="search-results">
        <li *ngFor="let step of filteredSteps" (click)="onStepClicked(step.step)">
            <mat-icon class="mr-2">arrow_right</mat-icon> {{ step.label }}
        </li>
    </ul>
    }

    <div mat-dialog-actions class="actions-container" align="end">
        <button mat-flat-button [mat-dialog-close]="true" class="save-btn" *ngIf="data.firstBtn">
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button mat-dialog-close *ngIf="data.secondBtn" class="cancel-btn">
            {{ data.secondBtn }}
        </button>
    </div>
</div>

<div class="gif-dialog-container" *ngIf="data.componentName === DialogInvokingComponents.GifShow">
    <!-- <div mat-dialog-content> -->
    <div class="gif-wrapper">
        <img [src]="data.image" alt="{{ data.title }}" class="dialog-gif" />
    </div>
    <!-- </div> -->

    <div mat-dialog-actions class="actions-container" align="end">
        <button mat-flat-button [mat-dialog-close]="true" class="save-btn" *ngIf="data.firstBtn">
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button mat-dialog-close *ngIf="data.secondBtn" class="cancel-btn">
            {{ data.secondBtn }}
        </button>
    </div>
</div>

<div class="shape-count-dialog-container" *ngIf="data.componentName === DialogInvokingComponents.ProductDetailPage">
    <div class="top-container">
        <p class="title">
            {{ data.title }}
        </p>

        <app-button variant="ghost" size="icon" (onClick)="closeDialog()">
            <mat-icon>close</mat-icon>
        </app-button>
    </div>
    <section class="shape-count-container mat-elevation-z1" tabindex="0">
        <table mat-table [dataSource]="dataSource">
            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>
                    {{ "genericDialogBox.label.name" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                <td mat-footer-cell *matFooterCellDef>
                    {{ "genericDialogBox.label.total" | translate }}
                </td>
            </ng-container>

            <!-- Count Column -->
            <ng-container matColumnDef="count">
                <th mat-header-cell *matHeaderCellDef>
                    {{ "genericDialogBox.label.count" | translate }}
                </th>
                <td mat-cell *matCellDef="let element">{{ element.count }}</td>
                <td mat-footer-cell *matFooterCellDef>{{ data.value }}</td>
            </ng-container>
            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <!-- Data Row -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
        </table>
    </section>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.LoadMyStructures">
    <div class="top-container">
        <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
        <button mat-icon-button class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Search bar -->
    <div class="search-container">
        <app-search-bar
            [label]="'genericDialogBox.label.search' | translate"
            [placeholder]="'genericDialogBox.placeHolder.searchStructure' | translate"
            [initialValue]="searchTerm"
            [debounceTime]="500"
            (search)="searchStructures($event)"
            [suffixCloseIcon]="'close'"
            [suffixSearchIcon]="'search'"
        >
        </app-search-bar>
    </div>

    <!-- Dialog Content (Apply overlay only inside here) -->
    <div mat-dialog-content class="mat-typography dialog-content-wrapper">
        <!-- Loader overlay inside dialog-content only -->
        <div class="loading-overlay" *ngIf="isLoading">
            <mat-spinner diameter="60"></mat-spinner>
        </div>

        <!-- Keep displaying old data until new data arrives -->
        <div class="structure-list" *ngIf="structures.count > 0">
            @for (structure of structures.rows; track structure.id) {
            <div class="structure-item" (click)="selectStructure(structure.id)">
                <div class="structure-avatar">
                    <mat-icon>description</mat-icon>
                </div>

                <div class="structure-content">
                    <div class="structure-header">
                        <span class="structure-name truncate">
                            {{ structure.structureName }}
                        </span>
                        <span class="structure-status" [ngClass]="'status-' + structure.status!.toLowerCase()">
                            {{ structure.status }}
                        </span>
                    </div>

                    <div class="structure-dates truncate">
                        <span class="date-label">{{ "genericDialogBox.loadStructure.created" | translate }}:</span>
                        {{ structure.createdAt | date: "dd/MM/yy, h:mm a" }}
                        <span class="date-separator">|</span>
                        <span class="date-label">{{ "genericDialogBox.loadStructure.updated" | translate }}:</span>
                        {{ structure.updatedAt | date: "dd/MM/yy, h:mm a" }}
                    </div>
                </div>
            </div>
            }
        </div>

        <!-- Show 'No structures found' when API response is empty -->
        <div class="no-results" *ngIf="!isLoading && structures.count === 0">
            <mat-icon>search_off</mat-icon>
            <p>{{ "genericDialogBox.noData.noStructureFound" | translate }}</p>
        </div>
    </div>

    <mat-paginator
        [length]="pagination.totalItems"
        [pageSize]="pagination.pageSize"
        [pageIndex]="pagination.currentPage"
        (page)="changePage($event.pageIndex)"
    >
    </mat-paginator>
</div>

<div *ngIf="data.componentName === DialogInvokingComponents.ConfirmationCurrentStructure">
    <div class="top-container">
        <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
        <button mat-icon-button class="close-button" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
        <div class="item-container">
            <p>{{ data.content }}</p>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <button mat-flat-button class="save-btn" [mat-dialog-close]="buttonData.Replace">
            {{ data.firstBtn }}
        </button>
        <button mat-flat-button [mat-dialog-close]="buttonData.Save" *ngIf="data.secondBtn" class="cancel-btn">
            {{ data.secondBtn }}
        </button>
    </mat-dialog-actions>
</div>

<form
    [formGroup]="loginForm"
    (keydown.enter)="$event.preventDefault()"
    (ngSubmit)="onSubmit()"
    class="login-container"
    *ngIf="
        data.componentName === DialogInvokingComponents.LoginDialog &&
        (loginState === LoginState.Mobile || loginState === LoginState.Otp)
    "
>
    <app-button variant="ghost" class="login-close-button" size="icon" (click)="closeDialog()" *ngIf="!data.isDesigner">
        <mat-icon class="login-close-icon" mat-dialog-close="true">close</mat-icon>
    </app-button>
    <mat-card class="login-image-container" *ngIf="loginState === LoginState.Mobile || loginState === LoginState.Otp">
        <img class="login-image" src="../../../assets/login-image.png" />
    </mat-card>

    @if (loginState === LoginState.Mobile) {
    <div class="phone-number-section">
        <app-button
            type="button"
            variant="hero"
            size="xl"
            (onClick)="continueAsGuest()"
            buttonClass="explore-btn"
            *ngIf="data.isDesigner"
        >
            {{ "genericDialogBox.login.button.continueAsGuest" | translate }}
        </app-button>

        <div class="separator-with-text" *ngIf="data.isDesigner">
            <span>{{ "genericDialogBox.login.or" | translate }}</span>
        </div>

        <p class="signin-text">{{ "genericDialogBox.login.signInRegister" | translate }}</p>

        <div class="phone-number-form-field">
            <div
                class="input-container"
                [ngClass]="{
                    error: loginForm.get('mobileNumber')?.invalid && loginForm.get('mobileNumber')?.touched
                }"
            >
                <span class="country-code">+91</span>
                <span> | </span>
                <input
                    type="text"
                    class="phone-number-input"
                    placeholder="{{ 'genericDialogBox.login.placeholder.mobile' | translate }}"
                    formControlName="mobileNumber"
                    maxlength="10"
                />
            </div>

            <div
                class="error-message"
                *ngIf="loginForm.get('mobileNumber')?.hasError('required') && loginForm.get('mobileNumber')?.touched"
            >
                {{ "genericDialogBox.login.mobileReq" | translate }}
            </div>
            <div
                class="error-message"
                *ngIf="loginForm.get('mobileNumber')?.hasError('pattern') && loginForm.get('mobileNumber')?.touched"
            >
                {{ "genericDialogBox.login.validMobile" | translate }}
            </div>
        </div>

        <div class="check-box-container">
            <mat-checkbox formControlName="agreeTerms" class="agreement-checkbox">
                <span class="agreement-text"
                    >By continuing, I agree to the
                    <a class="help-link" routerLink="/terms-and-conditions" [mat-dialog-close]="true">Terms of Use</a> &
                    <a class="help-link" routerLink="/privacy-policy" [mat-dialog-close]="true">Privacy Policy</a>
                </span>
            </mat-checkbox>
        </div>

        <!-- Send OTP Button -->
        <app-button
            variant="white"
            buttonClass="explore-btn"
            size="xl"
            [disabled]="loginForm.invalid || isSubmitting"
            type="submit"
        >
            <ng-container *ngIf="!isSubmitting; else loading">
                {{ "genericDialogBox.login.button.continue" | translate }}
            </ng-container>
            <ng-template #loading>
                <mat-progress-spinner diameter="20" mode="indeterminate" color="accent"> </mat-progress-spinner>
            </ng-template>
        </app-button>

        <div class="help-text-container">
            <p class="help-text">
                {{ "genericDialogBox.login.trouble" | translate
                }}<a class="help-link">{{ "genericDialogBox.login.getHelp" | translate }}</a>
            </p>
        </div>
    </div>
    } @else if(loginState === LoginState.Otp) {
    <div class="otp-section">
        <div class="otp-heading" *ngIf="!showResendLink">
            <p class="verify-text">{{ "genericDialogBox.login.verifyMobile" | translate }}</p>
            <p class="otp-text">{{ "genericDialogBox.login.enterOtp" | translate }}</p>
        </div>
        <div class="otp-input">
            <ng-otp-input
                [config]="{ length: 6, allowNumbersOnly: true }"
                (onInputChange)="onOtpChange($event)"
                *ngIf="!showResendLink"
            ></ng-otp-input>
            <p class="otp-error" *ngIf="!isSubmitting && !isOtpCorrect && !showResendLink">
                {{ otpFailedMessage | translate }}
            </p>

            <!-- Show loader when submitting -->
            <div class="loader-container" *ngIf="isSubmitting">
                <mat-spinner diameter="40"></mat-spinner>
            </div>

            <div class="otp-errors" *ngIf="loginForm.get('otp')?.invalid && loginForm.get('otp')?.touched">
                <mat-error *ngIf="loginForm.get('otp')?.hasError('required')">
                    {{ "genericDialogBox.login.otpReq" | translate }}
                </mat-error>
                <mat-error *ngIf="loginForm.get('otp')?.hasError('pattern')">
                    {{ "genericDialogBox.login.validOtp" | translate }}
                </mat-error>
            </div>
        </div>

        <!-- Verify OTP Button -->
        <div class="custm-btn">
            <!-- Now we do not need the Continue button after the OTP is entered, because we automatically trigger it when all 6 digits are filled. -->

            <!-- <app-button
                variant="white"
                size="xl"
                buttonClass="explore-btn"
                [disabled]="loginForm.invalid || isSubmitting || isInputFieldInValid()"
                type="submit"
                *ngIf="!showResendLink"
            >
                <ng-container *ngIf="!isSubmitting; else loading">
                    {{ "genericDialogBox.login.button.continue" | translate }}
                </ng-container>
                <ng-template #loading>
                    <mat-progress-spinner diameter="20" mode="indeterminate" color="accent"> </mat-progress-spinner>
                </ng-template>
            </app-button> -->

            <!-- resend OTP button  -->
            <app-button variant="white" buttonClass="shadow-btn" size="lg" *ngIf="showResendLink" (click)="resendOTP()">
                {{ "login.resendOTP" | translate }}
            </app-button>
        </div>

        <div *ngIf="showOTPField">
            <!-- The timer will blink every second when the remaining time is less than 30s -->
            <div
                class="timer"
                *ngIf="!isSubmitting && showTimer"
                [ngClass]="{ 'blink-alert': seconds < 30 && minutes < 1 }"
            >
                {{ timerDuration }}
            </div>
        </div>

        <div class="help-text-container">
            <p class="help-text">
                {{ "genericDialogBox.login.trouble" | translate
                }}<a class="help-link">{{ "genericDialogBox.login.getHelp" | translate }}</a>
            </p>
        </div>
    </div>
    }

    <!-- The part of the code is commented because now there is no need to show anything in the UI after the OTP is successful or not successful. -->

    <!-- @else if (loginState === LoginState.Success) {
    <div class="success-container">
        <mat-icon class="check-icon">check</mat-icon>

        <div class="succes-text">
            <span>{{ "genericDialogBox.login.success" | translate }}</span>
        </div>

        <div class="success-continue-container" (click)="loginContinue()" [mat-dialog-close]="true">
            <span>{{ "genericDialogBox.login.continue" | translate }}</span
            ><mat-icon class="chevron-right-icon">chevron_right</mat-icon>
        </div>
    </div>
    } @else if (loginState === LoginState.Failure) {
    <div class="success-container">
        <mat-icon class="unsuccess-close-icon">close</mat-icon>

        <div class="succes-text">
            <span>{{ "genericDialogBox.login.unsuccesss" | translate }}</span>
        </div>

        <div class="success-continue-container" (click)="closeDialog()">
            <span>{{ "genericDialogBox.login.continue" | translate }}</span
            ><mat-icon class="chevron-right-icon">chevron_right</mat-icon>
        </div>
    </div>
    } -->
</form>

<form class="payment-container" *ngIf="data.componentName === DialogInvokingComponents.PaymentDialog">
    <div class="payment-header-content">
        <span class="payment-header">{{ "genericDialogBox.payment.heading" | translate }}</span>
        <mat-icon class="payment-close-icon" (click)="closeDialog()">close</mat-icon>
    </div>
    <div class="payment-middle-content">
        <mat-radio-group class="payment-option" [(ngModel)]="selectedPayment" name="paymentMethod">
            <mat-radio-button [value]="PaymentMethod.CashOnDelivery" [disabled]="!isUserloggedIn">{{
                "genericDialogBox.payment.option.cod" | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="PaymentMethod.OnlinePayment">{{
                "genericDialogBox.payment.option.online" | translate
            }}</mat-radio-button>
            <div *ngIf="!isUserloggedIn" class="cod-warning">
                {{ "genericDialogBox.payment.codLoginRequiredMessage" | translate }}
            </div>
        </mat-radio-group>
        <div *ngIf="data.totalCoinBalance !== 0">
            <mat-checkbox [(ngModel)]="isCoinUsed" (change)="onCoinToggle()" name="isCoinUsed">{{
                "genericDialogBox.payment.reward" | translate: { coins: data.totalCoinBalance }
            }}</mat-checkbox>
        </div>
        <div class="Payment-button-container">
            <button class="save-btn" mat-flat-button [mat-dialog-close]="{ paymentOption: selectedPayment }">
                {{ "checkout.button.payNowBtn" | translate }}
            </button>
        </div>
    </div>
</form>

<div class="help-container" *ngIf="data.componentName === DialogInvokingComponents.HelpMessage">
    <div class="help-close-icon">
        <mat-icon class="payment-close-icon" (click)="closeDialog()">close</mat-icon>
    </div>

    <div class="help-heading-content">
        <p class="help-heading">{{ "genericDialogBox.help.title" | translate }}</p>
    </div>

    <div class="help-query-input-container">
        <input
            class="help-query-input"
            [(ngModel)]="helpQuery"
            name="helpQuery"
            type="text"
            autocomplete="off"
            placeholder="{{ 'genericDialogBox.help.placeHolder.message' | translate }}"
        />
    </div>

    <div class="help-button-container">
        <button
            class="save-btn"
            [disabled]="!helpQuery || !helpQuery.trim()"
            [mat-dialog-close]="{ helpQuery: helpQuery }"
            mat-flat-button
        >
            {{ "genericDialogBox.help.button.continueBtn" | translate }}
        </button>
    </div>
</div>

<div class="coupon-container" *ngIf="data.componentName === DialogInvokingComponents.CouponDialog">
    <div class="coupon-heading">
        <span>Coupons:</span>
        <span (click)="closeDialog()"><mat-icon class="payment-close-icon">close</mat-icon></span>
    </div>

    <div class="payment-bottom-coupon-section" *ngIf="data.availableCoupons.length; else noCoupon">
        <div class="coupon-wrapper" *ngFor="let coupon of data.availableCoupons">
            <div class="triangle"></div>
            <div class="coupon-content">
                <div class="coupon-text-container">
                    <p>{{ coupon.description }}</p>
                    <p>{{ "genericDialogBox.coupon.code" | translate }}: {{ coupon.couponCode }}</p>
                </div>
                <div class="copy-icon-container">
                    <mat-icon (click)="copyToClipboard(coupon.couponCode)">content_copy</mat-icon>
                </div>
            </div>
        </div>
    </div>

    <ng-template #noCoupon>
        <div class="no-coupon-container">
            <p class="no-coupon-heading">{{ "genericDialogBox.coupon.couponNotFound" | translate }}</p>
            <p class="second-text">{{ "genericDialogBox.coupon.noCouponAvaialble" | translate }}</p>
        </div>
    </ng-template>
</div>

<!-- cart dialog -->
<div
    class="cart-container"
    *ngIf="
        data.componentName === DialogInvokingComponents.RemoveFromWishlist ||
        data.componentName === DialogInvokingComponents.RemoveFromCart ||
        data.componentName === DialogInvokingComponents.UnavailableProducts
    "
>
    <div class="cart-top-container">
        <h2 class="cart-title" mat-dialog-title>{{ data.title }}</h2>
        <app-button [variant]="'ghost'" [buttonClass]="'circle-btn'" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </app-button>
    </div>
    <mat-dialog-content class="mat-typography">
        <div class="item-container">
            <div class="image-container" *ngIf="data.componentName !== DialogInvokingComponents.UnavailableProducts">
                <div class="image">
                    <img [src]="data.image" alt="Product Image" *ngIf="data.image; else noImage" />

                    <ng-template #noImage>
                        <div class="image-placeholder"></div>
                    </ng-template>
                </div>
            </div>
            <p>{{ data.content }}</p>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="actions-container" align="end">
        <app-button variant="hero" buttonClass="explore-btn" [mat-dialog-close]="'remove'">
            {{ data.firstBtn }}
        </app-button>
        <app-button
            variant="hero"
            *ngIf="data.secondBtn"
            buttonClass="explore-btn shadow-btn"
            [mat-dialog-close]="'move'"
        >
            {{ data.secondBtn }}
        </app-button>
    </mat-dialog-actions>
</div>

<div class="chat-container" *ngIf="data.componentName === DialogInvokingComponents.ChatDialog">
    <div class="title-container">
        <p class="title">Chat</p>
        <app-button (click)="closeDialog()" [variant]="'ghost'" [buttonClass]="'circle-btn'">
            <mat-icon>close</mat-icon>
        </app-button>
    </div>

    <div class="chat-messages" #messageContainer>
        <div class="chat-message" *ngFor="let message of messages" [ngClass]="getMessageClass(message)">
            <div class="bubble">
                <p>{{ message.body }}</p>
                <span>{{ message.createdAt | date: "shortTime" }}</span>
            </div>
        </div>
    </div>
</div>
